import api from '@/api/orderType'

const systemTypes = [
    'Pick',
    'Pack',
    'Receival Note',
    'Delivery',
    'Service',
    'Restocking',
    'Invoice',
]

const state = {
    item: null,
    items: [],
    systemTypes,
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(() => {
                context.dispatch('fetchAll')
            })
            .catch(err => {
                throw err
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('fetch item', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                throw err
            })
    },

    fetchAll(context) {
        return api
            .fetchAll()
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('fetchall', data)
                    context.commit('set_items', data)
                }
            )
            .catch(err => {
                throw err
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(() => {
                context.dispatch('fetchAll')
            })
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.dispatch('fetchAll')
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
